import type { HandlerFunction } from "../types";
import { useBillingStore } from "~/stores/billing";
import type Organisation from "../../../../../backend/app/models/organisation";

/**
 * Owner message handler
 *
 * Handles owner-specific SSE events including:
 * - Billing updates
 * - Subscription changes
 * - Admin alerts
 * - Store updates
 */
interface OwnerMessage {
  type: string;
  refresh?: boolean;
  message?: string;
  title?: string;
  orga?: Organisation;
}

export const handleOwnerMessage: HandlerFunction = (data: OwnerMessage) => {
  const toast = useToast();
  const billing = useBillingStore();
  const auth = useAuthStore();

  // console.log("[SSE] [handleOwnerMessage]:", data);
  switch (data.type) {
    case "billing_update":
      // Update billing information
      break;

    case "subscription_change":
      // Handle subscription changes
      break;

    case "admin_alert":
      // Show admin alert
      break;

    case "store":
      if (data.refresh) billing.needRefresh = true;
      if (data.message) {
        toast.add({
          title: data.title || "Success",
          description: data.message,
          color: "group_indigo",
          icon: "i-heroicons-credit-card",
        });
      }
      if (data.orga) auth.orga = data.orga;
      break;

    default:
      console.log("Unknown owner message type:", data.type);
  }
};
